import { ENV } from 'config';

import { AnalyticsConfig, AnalyticsProvider } from './types';

declare global {
    interface Window {
        clarity?(...args: unknown[]): void;
    }
}

let active = false;

const Clarity: AnalyticsProvider = {
    init: (config: AnalyticsConfig) => {
        if (!ENV.CLARITY_ID || !config.clarityEnabled) {
            return;
        }

        (function(c, l, a, r, i, t, y){
            // @ts-ignore
            c[a] = c[a] || function() {
                // @ts-ignore
                // eslint-disable-next-line prefer-rest-params
                (c[a].q = c[a].q || []).push(arguments);
            };

            // @ts-ignore
            t = l.createElement(r); t.async = 1; t.src = `https://www.clarity.ms/tag/${ i }`;
            // @ts-ignore
            y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
        })(window, document, 'clarity', 'script', ENV.CLARITY_ID);

        active = true;
    },
    event: (name: string, data?: Record<string, unknown>) => {
        if (active && typeof window.clarity === 'function') {
            window.clarity('event', name, data);
        }
    }
};

export default Clarity;
